import { useEffect } from 'react';
import { PageContainer, Tile } from 'components/Layout/PageContainer';
import { useInfoDrawer } from 'context/InfoDrawerContext';
import { GmvCategoryBreakdownInfoContent } from './GmvCategoryBreakdownInfoContent';
import { GmvCategoryBreakdownTable } from './GmvCategoryBreakdownTable';

export function GmvCategoryBreakdown() {
  const { setContent } = useInfoDrawer();

  useEffect(() => {
    setContent({
      titleKey: 'insights.category.reports.channel_breakdown',
      subtitleKey: 'info.content.all_dates_utc',
      content: <GmvCategoryBreakdownInfoContent />,
    });

    return () => {
      setContent(null);
    };
  }, [setContent]);

  return (
    <PageContainer>
      <Tile className="text-lg p-4" titleId="insights.category.reports.channel_breakdown" />
      <GmvCategoryBreakdownTable />
    </PageContainer>
  );
}
